import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { IonContent, LoadingController } from '@ionic/angular';
import { WebcontentComponent } from 'src/app/components/webcontent/webcontent.component';
import { ConfigService } from 'src/app/services/config/config.service';
import { WebcontentService } from 'src/app/services/webcontent/webcontent.service';

@Component({
  selector: 'app-content-placeholder',
  templateUrl: './content-placeholder.component.html',
  styleUrls: ['./content-placeholder.component.scss'],
})
export class ContentPlaceholderComponent implements OnInit {

  @ViewChild(IonContent, { static: false }) content: IonContent;
  @Input() link: string;

  public loading: any;
  public title: string;

  constructor(
    private configService: ConfigService,
    public loadingController: LoadingController,
    private webcontentService: WebcontentService
  ){
  }

  ngOnInit(){
    const url: string = this.getURL();
    console.log(url);
    this.webcontentService.updateExternalLink(url);
    this.title = this.configService.getExternalLinks().payload.filter(link => link.code == this.link)[0].title;
  }

  async showLoading() {
    this.loading = await this.loadingController.create({
      message: 'Please wait loading...',
      duration: 1200
    });
  
    this.loading.present();
  }

  public getURL(): string{
    const url = this.configService.getExternalLinks().payload.filter(link => link.code == this.link)[0].url;
    return url;
  }

}
